import { BASE_ADMIN_API, fetchAPI } from '@/services/api';

export interface OcrTess4jConfig {
    lang?: string;
}

export interface OcrAiConfig {
    enabled?: boolean;
    apiUrl?: string;
    apiKey?: string;
    model?: string;
}

export interface OcrCloudConfig {
    enabled?: boolean;
    vendor?: string;
    accessKey?: string;
    secretKey?: string;
    endpoint?: string;
}

export interface OcrPaddleConfig {
    enabled?: boolean;
    serviceUrl?: string;
}

export interface OcrConfigVO {
    provider?: string;
    tess4j?: OcrTess4jConfig;
    ai?: OcrAiConfig;
    cloud?: OcrCloudConfig;
    paddle?: OcrPaddleConfig;
}

export interface OcrConfigBO extends OcrConfigVO {
    provider: string;
}

const base = `${BASE_ADMIN_API}/ocr-config`;

export async function getConfig() {
    return fetchAPI<OcrConfigVO>(`${base}/get`, { method: 'GET' });
}

export async function updateConfig(bo: OcrConfigBO) {
    return fetchAPI<boolean>(`${base}/update`, {
        method: 'PUT',
        body: JSON.stringify(bo),
    });
}

export const OcrConfigService = {
    getConfig,
    updateConfig,
};
